import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  container: {
    position: "absolute",
    padding: theme.spacing(2.5),
    width: 320,
    height: "fit-content",
    borderRadius: 10,
    background: theme.palette.white,
    top: 0,
    bottom: 0,
    left: 0,
    margin: "auto",
    right: 0,
  },
  messageBox: {
    display: "flex",
    marginBottom: theme.spacing(2.5),
  },
  countDownBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    marginBottom: theme.spacing(2.5),
    "& .MuiCircularProgress-root": {
      color: theme.palette.events.bluePrimary,
    },
  },
  countDown: {
    position: "absolute",
    fontSize: theme.spacing(3.75),
  },
  message: {
    marginLeft: theme.spacing(1.25),
  },
  wrapConversation: {
    textAlign: "center",
    marginBottom: theme.spacing(2.5),
  },
  moveBox: {
    marginTop: 10,
    width: "100%",
  },
  moveButton: {
    width: "100%",
  },
}));
